import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import listItems from 'flarum/common/helpers/listItems';
import Link from 'flarum/common/components/Link';
import avatar from 'flarum/common/helpers/avatar';

import UserControls from 'flarum/forum/utils/UserControls';
import UserPage from 'flarum/forum/components/UserPage';
import UserCard from 'flarum/forum/components/UserCard';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import Dropdown from 'flarum/common/components/Dropdown';

import humanTime from 'flarum/common/utils/humanTime';
import ItemList from 'flarum/common/utils/ItemList';
import username from 'flarum/common/helpers/username';
import icon from 'flarum/common/helpers/icon';
import LevelBar from './components/LevelBar';

import classList from 'flarum/common/utils/classList';

export default function () {
  extend(UserCard.prototype, 'infoItems', function (items) {
    if (items.has('custom-levels')) {
      items.remove('custom-levels');
    }
    return items;
  });

  override(UserCard.prototype, 'view', function () {
    const user = this.attrs.user;
    const controls = UserControls.controls(user, this).toArray();
    const color = user.color();
    const badges = user.badges() ? user.badges().toArray() : [];
    const bgBannerImgUrl = app.forum.attribute('baseUrl') + '/assets/images/banner_linear_200_f.png';
    return (
      <div className={classList('UserCard', this.attrs.className)} style={{ background: `url(${bgBannerImgUrl}) no-repeat center top` }}>
        <div className="darkenBackground">
          <div className="container">
            {!!controls.length && (
              <Dropdown
                className="UserCard-controls App-primaryControl"
                menuClassName="Dropdown-menu--right"
                buttonClassName={this.attrs.controlsButtonClassName}
                label={app.translator.trans('core.forum.user_controls.button')}
                accessibleToggleLabel={app.translator.trans('core.forum.user_controls.toggle_dropdown_accessible_label')}
                icon="fas fa-ellipsis-v"
              >
                {controls}
              </Dropdown>
            )}

            <div className="UserCard-profile">
              <h1 className="UserCard-identity">
                {this.attrs.editable ? (
                  <>
                    <AvatarEditor user={user} className="UserCard-avatar" /> {username(user)}
                  </>
                ) : (
                  <Link href={app.route.user(user)}>
                    <div className="UserCard-avatar">{avatar(user, { loading: 'eager' })}</div>
                    {username(user)}
                  </Link>
                )}
              </h1>

              {!!badges.length && <ul className="UserCard-badges badges">{listItems(badges)}</ul>}
              <LevelBar user={user} />
              <ul className="UserCard-info">{listItems(this.infoItems().toArray())}</ul>
            </div>
          </div>
        </div>
      </div>
    );
  });
}
